// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Area.yaml
// Generated: 2026-10-20T12:35:06.074Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateArea, UpdateArea, Area } from '@/types/core/Area';

/**
 * Area Service
 * CRUD operations for Area via the ABP API.
 */
export const areaService = new EntityService<Area, CreateArea, UpdateArea>(
  '/api/core/area',
  'Area',
);
